// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19ymH","placeholdersHeader":"styles_placeholdersHeader__2afRS","editorStyle":"styles_editorStyle__1jczV","placeholdersBox":"styles_placeholdersBox__2mvaY"};